import { baseURL } from "../ApiConstant";
import { CommonApiResponse } from "../../Controllers/Types/ApiResponse";
import apiClient from "../apiClient";
import { AttendanceTakenType } from "../../Controllers/Types/HeyTraderTypes/Attendances/AttendanceTakenType";
import { ShareContactType } from "../../Controllers/Types/Share/ShareContactType";

// get contact employee list
export const getContactEmployeeListService = async () => {
  try {
    const response = await apiClient.get(`/api/contact-employee-list`);

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

// get attendance employee list
export const getAttendanceEmployeeListService = async (date?: string | null) => {
  try {
    const endpoint = date
      ? `/api/attendance-employee-list/${date}`
      : `/api/attendance-employee-list`;

    const response = await apiClient.get(endpoint);

    if (response.status === 200) {
      return { status: true, body: response.data };
    }

    return { status: false, error: "Failed to fetch data." };

  } catch (error: any) {
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};


//   add attendancesEmployee
export const addAttendancesEmployee = async (
  personal_info_id: number | null,
  work_type: 'Day' | 'Hour',
  daily_hours: number | null,
  daily_wage: number
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/attendance-employee-add`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ personal_info_id, work_type, daily_hours, daily_wage }),
    });
    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

//   update attendancesEmployee
export const updateAttendancesEmployee = async (
  work_type: 'Day' | 'Hour',
  daily_hours: number | null,
  daily_wage: number,
  id: number | null
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/attendance-employee-update/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: JSON.stringify({ work_type, daily_hours, daily_wage }),
      }
    );
    const data = await response.json();
    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

//   active attendancesEmployee
export const activeAttendancesEmployee = async (
  id: number
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/attendance-employee-status-changed/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
      }
    );
    const data = await response.json();
    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

//   make attendance request later
export const getAttendanceTakenListService = async (
  attendance_date: string
) => {
  const input = {
    attendance_date: attendance_date,
  };
  try {
    const response = await apiClient.post(`/api/attendance-taken-list`, input);

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

//   make attendance home request later
export const getAttendanceHomeListService = async (attendance_date: string) => {
  const input = {
    attendance_date: attendance_date,
  };
  try {
    const response = await apiClient.post(`/api/attendance-home-data`, input);
    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

//   add attendances
export const addAttendances = async (
  attendance_date: string,
  totallist: AttendanceTakenType[]
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const list = totallist.map((e) => e.attendanceData);
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/attendance-add`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ attendance_date, list }),
    });
    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// Delete attendance
export const deleteAttendanceData = async (
  personal_info_id: number,
  attendance_date: string
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;

    const response = await fetch(`${baseURL}/api/attendance-delete`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ personal_info_id, attendance_date }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return { status: false, statusCode: 422, massage: "Body error" };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

//   make attendance request by selected employee and month.
export const getAttendanceByEmployeeService = async (collection: string[]) => {
  const input = {
    personal_info_id: collection[0],
    month: collection[1],
  };

  try {
    const response = await apiClient.post(
      `/api/one-employee-attendance`,
      input
    );
    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};


// multiple dates with sigle employe
export const getAttendanceByEmployeeServiceBetweenDates = async (personal_info_id: number | null, start_date: string, end_date: string) => {
  const input = {
    personal_info_id: personal_info_id,
    start_date: start_date,
    end_date: end_date,
  };

  try {
    const response = await apiClient.post(
      `/api/one-employee-attendance-between-date`,
      input
    );


    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

// attendance project types
export const getAttendanceProjectListService = async () => {
  try {
    const response = await apiClient.get(`/api/attendance-project-list`);
    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

// share clinet account detaills
export const shareProjectAttendance = async (
  share: ShareContactType[],
  project_id: number
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/attendance-share`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: JSON.stringify({ project_id, share }),
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// material share function
export const shareAttendanceNewAPI = async (
  share: ShareContactType[],
  project_id: number
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/attendance-share`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ project_id, share }),
    });

    const data = await response.json();

    console.log("Data sending options", data);

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};
